module.exports = __webpack_public_path__ + "c54676153e675fdf7f4a0d7c8219c815.png";